// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".small-callback__title[data-v-83831e80]{font-size:13px;cursor:pointer;border-bottom-width:0}@media (max-width:1140px){.small-callback__title[data-v-83831e80]{font-size:13px;border-bottom-width:1px}}@media (max-width:950px){.small-callback__title[data-v-83831e80]{font-size:12px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
